import { Navigate } from 'react-router-dom'

export function AdminTeamInvitePage() {
  return <Navigate to="/admin/team" replace />
}
